import { FinancialAccountSubtype, TransactionSolution, TransactionSolutionDisplayName } from '@shared/models';
import { Patterns } from '@shared/utils/patterns';

export const getSolutionDisplayName = (value?: TransactionSolution): TransactionSolutionDisplayName => {
  if (!value) {
    return '';
  }

  const solutionNames: Record<TransactionSolution, TransactionSolutionDisplayName> = {
    ach: 'ACH',
    'push-to-card': 'Push To Card',
    transfer: 'Transfer',
    wire: 'Wire',
    'millikart-transaction': 'Millikart Transaction',
    'i2c-transaction': 'I2C Transaction',
    'cards-transaction': 'Cards Transaction',
    'financial-account-aggregation': 'Financial Account Aggregation',
  };

  return solutionNames[value] || '';
};

export const getSubtypeDisplayName = (value?: FinancialAccountSubtype): string | undefined => {
  if (!value) {
    return;
  }

  const subtypeNames: Record<FinancialAccountSubtype, string> = {
    CHECKING: 'CHK',
    SAVING: 'SAV',
    CREDIT: 'CRD',
    DEBIT: 'DBT',
    GIFT: 'GFT',
    PREPAID: 'PRP',
    TOKENIZED: 'TKN',
  };

  return subtypeNames[value] || undefined;
};

export const getMaskedAccountNumber = (str: string | undefined): string | undefined => {
  if (!str) {
    return;
  }

  return `*${str}`.replace(Patterns.MASKED_NUMBER, '');
};
